import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'  // 导入ElementUI
import 'element-ui/lib/theme-chalk/index.css'  // 导入样式
import './assets/icon/iconfont.css'
import VueAnimateNumber from 'vue-animate-number'
// 全屏滚动 vue-fullpage.js
import VueFullPage from 'vue-fullpage.js'
// 导入Swiper的依赖
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import VueLazyload from 'vue-lazyload'
//主题色修改
import './assets/css/element-variables.scss'
//公共样式
import './assets/css/style.scss'
//引入字体样式
import './assets/css/font-H.css'
//引入全屏滚动样式
import './assets/css/fullpage.min.css'
Vue.use(VueLazyload)
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './assets/bg1.png',
  loading: './assets/bg1.png',
  attempt: 1
})
//main.js
Vue.use(VueAwesomeSwiper)
Vue.use(VueFullPage);
Vue.use(VueAnimateNumber)
Vue.use(ElementUI)
Vue.config.productionTip = false
new Vue({
  router,  // 将router写在这里
  render: h => h(App),
}).$mount('#app')


